import { render } from "./auth.vue?vue&type=template&id=a6586070"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=a6586070&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__